import { render, staticRenderFns } from "./ReleaseStep.vue?vue&type=template&id=1bd56435&scoped=true&"
import script from "./ReleaseStep.vue?vue&type=script&lang=js&"
export * from "./ReleaseStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd56435",
  null
  
)

export default component.exports